import { EligibilityVerificationType } from '@ktypes/enums';
import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class EligibilityVerification
  implements Serializable<JsonObject>, Deserializable<JsonObject, EligibilityVerification>
{
  constructor(
    public verificationType?: EligibilityVerificationType,
    public email?: string,
    public eligibilityId?: string,
    public firstName?: string,
    public lastName?: string,
    public postalCode?: string,
    public dateOfBirth?: string,
    public toWorkbook?: boolean,
    public sharingToken?: string
  ) {}

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['verificationType'] = this.verificationType;
    json['email'] = this.email;
    json['eligibilityId'] = this.eligibilityId;
    json['firstName'] = this.firstName;
    json['lastName'] = this.lastName;
    json['postalCode'] = this.postalCode;
    json['dateOfBirth'] = this.dateOfBirth;
    json['toWorkbook'] = this.toWorkbook;
    json['sharingToken'] = this.sharingToken;

    return json;
  }

  deserialize(input: JsonObject): EligibilityVerification {
    if (input == null) {
      return null;
    }
    this.verificationType = input['verificationType'] as EligibilityVerificationType;
    this.email = input['email'];
    this.eligibilityId = input['eligibilityId'];
    this.firstName = input['firstName'];
    this.lastName = input['lastName'];
    this.postalCode = input['postalCode'];
    this.dateOfBirth = input['dateOfBirth'];
    this.toWorkbook = input['toWorkbook'];
    this.sharingToken = input['sharingToken'];
    return this;
  }
}
